import { modalType } from '../../util/ModalUtil';
import { useDispatch } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID, ROLE } from '../../constant/Constant';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import SelectionBox from '../../component/SelectionBox';
import InputBox from '../../component/InputBox';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import PopupRef from '../../component/PopupRef';
import TelNoInputBox from '../../component/TelNoInputBox';
import { actionSearchDetail } from '../../module/body/system/SystemTermModule';
import { drawerClasses } from '@mui/material';
import { formatDateTimeString } from '../../util/TimeTableUtil';
import NullCheckUtil from '../../util/NullCheckUtil';

const UniversitySemesterModal = ({ semesterId, semesterNm, modalRef }) => {
    const dispatch = useDispatch();
    const popupRef = useRef(null);
    const [semesterInfo, setSemesterInfo] = useState([]);

    useEffect(() => {
        dispatch(
            actionSearchDetail({
                semesterId: semesterId,
                callback: (result) => {
                    setSemesterInfo(result);
                    console.log(result);
                },
            }),
        );
    }, []);

    const handleConfirm = () => {
        modalRef.current.close();
    };

    // const formatTime = (dt, time) => {
    //     if (NullCheckUtil.isEmpty(dt) || NullCheckUtil.isEmpty(time)) return;
    //     return (
    //         dt.substring(0, 4) +
    //         '-' +
    //         dt.substring(4, 6) +
    //         '-' +
    //         dt.substring(6, 8) +
    //         ' ' +
    //         time.substring(0, 2) +
    //         ':' +
    //         time.substring(2, 4)
    //     );
    // };

    const formatDate = (dt) => {
        if (NullCheckUtil.isEmpty(dt)) return;
        return dt.substring(0, 4) + '-' + dt.substring(4, 6) + '-' + dt.substring(6, 8);
    };

    const formatTime = (time) => {
        if (NullCheckUtil.isEmpty(time)) return;
        return time.substring(0, 2) + ':' + time.substring(2, 4);
    };

    return (
        <>
            <ModalHeader title='대학별 수강신청 기간' modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner UniversitySemesterModal'>
                    {/* TODO : CODE_GROUP_ID.ENROLMENT_TIME  */}
                    <InfoTxt
                        infoTxt={semesterNm + ' : 각 대학별 수강신청 기간중에만 수강신청 및 수강취소가 가능합니다.'}
                    />
                    <div>
                        <div className='time-info-table'>
                            <table>
                                <caption className='blind'>대학별 수강신청 기간</caption>
                                <colgroup>
                                    <col style={{ width: '30%' }} />
                                    <col style={{ width: '40%' }} />
                                    <col style={{ width: '30%' }} />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th scope='col'>대학</th>
                                        <th scope='col'>수강신청일자</th>
                                        <th scope='col'>수강신청시간</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* TODO : 대학별 수강신청 데이터 조회하여 화면 출력 처리 반영, 모든 COSS 참여 대학 출력 */}
                                    {semesterInfo?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.universityNm}</td>
                                            <td>
                                                {formatDate(item.enrolmentBgnDt)} ~ {formatDate(item.enrolmentEndDt)}
                                            </td>
                                            <td>
                                                {formatTime(item.enrolmentBgnTime)} ~{' '}
                                                {formatTime(item.enrolmentEndTime)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default UniversitySemesterModal;
